
/* injects from baggage-loader */

import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

export default class DayTime extends React.Component {
  static propTypes = {
    date: PropTypes.oneOfType([
      PropTypes.instanceOf(Date),
      PropTypes.string
    ]).isRequired,
    time: PropTypes.bool,
    day: PropTypes.bool,
    className: PropTypes.string
  }

  static contextTypes = {
    timezone: PropTypes.string
  }

  render() {
    const {date, className, time, day} = this.props
    const timeFormat = time ? 'HH:mm' : ''
    const dateFormat = 'YYYY-MM-DD'
    const dayFormat = day ? 'ddd' : ''
    const format = [dayFormat, dateFormat, timeFormat].join(' ')
    return (
      <span className={className}>{moment(date).format(format)}</span>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/DayTime/index.js